import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { EditableCustomerRow } from "@/components/shared/EditableCustomerRow";
import PoLinkStatus from "@/components/customers/PoLinkStatus";
import { countryName } from "@/lib/countries";
import type { CustomerDetail } from "@/hooks/use-customer-detail";

interface CustomerEditDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  customer: CustomerDetail;
}

/**
 * «Rediger» i heroen: kundens faste opplysninger (kontakt, faktura, adresse).
 * Radene lagres skrive-gjennom til PowerOffice via EditableCustomerRow, så
 * ingen verdi her kan avvike fra regnskapssystemet.
 */
export default function CustomerEditDialog({ open, onOpenChange, customer }: CustomerEditDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Rediger {customer.name}</DialogTitle>
          <DialogDescription>Klikk en verdi for å endre den. Endringer lagres i PowerOffice først.</DialogDescription>
        </DialogHeader>
        <div className="space-y-1 text-sm">
          <div className="flex items-center justify-between px-2 py-1">
            <span className="text-muted-foreground">Org.nr</span>
            <span className="font-medium">{customer.organization_number || "—"}</span>
          </div>
          <div className="flex items-center justify-between px-2 py-1">
            <span className="text-muted-foreground">Land</span>
            <span className="font-medium">{countryName(customer.country_code)}</span>
          </div>
          <EditableCustomerRow label="E-post" value={customer.contact_email} field="contact_email" customerId={customer.id} />
          <EditableCustomerRow label="Telefon" value={customer.contact_phone} field="contact_phone" customerId={customer.id} />
          <EditableCustomerRow
            label="Faktura-e-post"
            value={customer.invoice_email_address}
            field="invoice_email_address"
            customerId={customer.id}
            hint="Hit sendes fakturaen når prosjektet ikke overstyrer."
          />
          <EditableCustomerRow label="Faktura-kopi" value={customer.invoice_email_cc} field="invoice_email_cc" customerId={customer.id} />
          <EditableCustomerRow label="Adresse" value={customer.address} field="address" customerId={customer.id} />
          <EditableCustomerRow label="Postnummer" value={customer.postal_code} field="postal_code" customerId={customer.id} />
          <EditableCustomerRow label="Poststed" value={customer.city} field="city" customerId={customer.id} />
          <div className="px-2 pt-2">
            <PoLinkStatus customerId={customer.id} poCustomerId={customer.poweroffice_customer_id} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
